import { useOrderContainersContext } from '../../../../Contexts/OrderContainersContext'
import { useDestinationsContext } from '../../../../Contexts/DestinationsContext'
import React from 'react'
import { Col, Row, Tag } from 'antd'
import { DeleteFilled } from '@ant-design/icons'
import { useWizardMaster } from '../../../../Contexts/WizardMasterContext'
import { isTruckLoaded } from '../../../../util'
import { DestinationSwitcher } from './PocketControls/DestinationSwitcher'
import { PocketTarget } from './PocketControls/PocketTarget'
import { GraviButton, BBDTag, Texto, Vertical, Horizontal } from '@gravitate-js/excalibrr'

export const AllocatedPocket = ({ container, index, editable, isError }) => {
  const { deletePocket, changeTargetLocation } = useOrderContainersContext()
  const { getImpactedTankVolumes, setOrderDestinations } = useDestinationsContext()
  const { wizardOrder } = useWizardMaster()
  const errorClass = isError ? 'error' : 'allocated'
  const truckIsLoaded = wizardOrder ? isTruckLoaded(wizardOrder.trip_status) : false
  const showErrorText = isError && container.targets.length === 1
  const showMuliGalTag = editable && container.targets && container.targets.length === 1
  const canEdit = editable && (!truckIsLoaded || container.targets.length > 1)
  const canDelete = editable && !truckIsLoaded

  return (
    <Vertical
      gap={8}
      border='all'
      style={{ height: 'auto' }}
      className={`pocket-container p-3 flex-1 ${errorClass} ${
        container?.targets?.some((t) => t.modified) ? 'modified' : ''
      }`}
    >
      <Horizontal style={{ flex: 1 }}>
        <Horizontal flex={3}>
          <BBDTag style={{ height: 'fit-content' }}> {index + 1} </BBDTag>
        </Horizontal>
        <Horizontal flex={11}>
          <Texto appearance='secondary' weight='bold'>
            {container.product_name}
          </Texto>
        </Horizontal>
        <Horizontal justifyContent='flex-end' flex={9}>
          <DestinationSwitcher editable={editable} isError={isError} container={container} index={index} />
        </Horizontal>
      </Horizontal>
      <Horizontal>
        <PocketTarget
          showGallonTag={!container.targets.length > 1}
          showMultiTarget={container.targets.length > 1}
          targetIndex={0}
          canEdit={canEdit}
          container={container}
          changeTargetLocation={changeTargetLocation}
          index={index}
        />

        {container.targets.length > 1 && (
          <PocketTarget
            showGallonTag={showMuliGalTag}
            showMultiTarget
            targetIndex={1}
            canEdit={canEdit}
            container={container}
            changeTargetLocation={changeTargetLocation}
            index={index}
          />
        )}
        {showErrorText && (
          <Col>
            <Texto appearance='error' className='pocket-error-message'>
              No Match{' '}
            </Texto>
          </Col>
        )}
        {canDelete && (
          <Col flex={1} className='vertical-flex justify-end items-end'>
            <GraviButton
              size='small'
              onClick={() => deletePocket(index, getImpactedTankVolumes, setOrderDestinations)}
              type='text'
              icon={<DeleteFilled />}
            />
          </Col>
        )}
      </Horizontal>
    </Vertical>
  )
}
